<template>
<div>
<Charges/>

</div>
</template>
<script>
import Charges from "../../components/Financial/Charges.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   Charges
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>